import {Logic} from "./CopilotContainer.interfaces";
import "./CopilotContainer.styles.scss";
import React, {useMemo} from "react";
import languageObject from "../../../../translations";
import {
    Button,
    ChevronDownIcon,
    ChevronEndIcon,
    Flex,
    Loader,
    Menu,
    Text,
    TextArea,
    WandIcon
} from "@fluentui/react-northstar";
import {brandColors} from "../../../../const/ThemeCustomizations";

export const CopilotContainerRendering = (logic: Logic) => {

    const trigger = useMemo(() => (
        <Button
            primary
            content={languageObject.translate("GenerateByCopilot")}
            iconPosition={"after"}
            fluid
            icon={logic.open ? <ChevronDownIcon outline/> : <ChevronEndIcon outline/>}
            onClick={logic.handleToggleOpen}
        />
    ), [logic.open]);

    const instructionTextarea = useMemo(() => (
        <Flex column>
            <Text styles={{color: "white"}} content={languageObject.translate("MessageSubject")}/>
            <TextArea
                placeholder={languageObject.translate("WriteSubjectOfMessage")}
                styles={{
                    border: "0",
                    borderRadius: "3px",
                    height: "60px",
                    maxHeight: "300px",
                    minHeight: "32px",
                    lineHeight: 1.1
                }}
                resize={"vertical"}
                autoComplete={"off"}
                fluid
                maxLength={500}
                value={logic.instruction}
                onChange={logic.handleChangeInstruction}
            />
        </Flex>
    ), [logic.instruction]);

    const tonePicker = useMemo(() => (
        <Flex column>
            <Text styles={{color: "white"}} content={languageObject.translate("Tone")}/>
            <Menu
                className={"copilot-container-form-menu"}
                fluid
                items={logic.availableTones}
                activeIndex={logic.activeToneIndex}
            />
        </Flex>
    ), [logic.activeToneIndex]);

    const lengthPicker = useMemo(() => (
        <Flex column>
            <Text styles={{color: "white"}} content={languageObject.translate("Length")}/>
            <Menu
                className={"copilot-container-form-menu"}
                fluid
                items={logic.availableLengths}
                activeIndex={logic.activeLengthIndex}
            />
        </Flex>
    ), [logic.activeLengthIndex]);

    const generateButton = useMemo(() => (
        <Button
            fluid
            tinted
            icon={logic.isGenerating ? <Loader size={"small"}/> : <WandIcon/>}
            content={languageObject.translate(logic.isGenerating ? "GenerationInProgress" : "Generate")}
            disabled={logic.isGenerating}
            onClick={logic.handleStartGeneration(logic.locale)}
        />
    ), [logic.isGenerating, logic.locale]);

    const className = [
        "copilot-container",
        logic.open ? "copilot-container-open" : "",
    ].join(" ");

    return (
        <Flex column className={className} styles={{backgroundColor: brandColors[600]}}>
            {trigger}
            {!logic.open ? null :
                <Flex column className={"copilot-container-form"}>
                    <Flex column styles={{gap: "10px", marginTop: "-15px"}}>
                        {instructionTextarea}
                        {tonePicker}
                        {lengthPicker}
                    </Flex>
                    <Flex>
                        {generateButton}
                    </Flex>
                </Flex>
            }
        </Flex>
    )
}